import FileInputContainer from './FileInputContainer.jsx';

export default FileInputContainer;
